import "antd/lib/dropdown/style";
import _Dropdown from "antd/lib/dropdown";
import "antd/lib/button/style";
import _Button from "antd/lib/button";
import _asyncToGenerator from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
var __jsx = React.createElement;
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "core-js/modules/es6.function.name.js";
import "core-js/modules/es7.array.includes.js";
import React, { useCallback, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { loadExperiments, setActiveExperiment } from 'redux/actions/experiments';
import { modules } from 'utils/constants';
import { useAppRouter } from 'utils/AppRouteProvider';
import fetchAPI from 'utils/http/fetchAPI';
import sendInvites from 'utils/data-management/experimentSharing/sendInvites';

// eslint-disable-next-line react/prop-types
var DropdownLabel = function DropdownLabel(_ref) {
  var title = _ref.title,
    description = _ref.description,
    key = _ref.key;
  return __jsx("div", {
    "aria-label": key,
    style: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'flex-start',
      maxWidth: '450px',
      whiteSpace: 'normal',
      wordWrap: 'break-word'
    }
  }, __jsx("span", null, title), __jsx("span", {
    style: {
      marginLeft: '10px',
      color: 'gray'
    }
  }, description));
};
var ExploreSelect = function ExploreSelect(props) {
  var experiment = props.experiment;
  var _useAppRouter = useAppRouter(),
    navigateTo = _useAppRouter.navigateTo;
  var dispatch = useDispatch();
  var userEmail = useSelector(function (state) {
    return state.user.current.attributes.email;
  });
  var _useState = useState(false),
    experimentCloning = _useState[0],
    setExperimentCloning = _useState[1];
  var disableCloneForExperiments = ['879080ff-e0a1-4dd4-9244-6b1bdc6e8514', 'ce0fa9ed-aed5-4f77-8d9d-3a108abc326f', '4810d1c9-c205-4711-acb3-294b229ddd42', 'cf3fe02e-1279-4176-84e4-a3611a602882'];
  var addAsViewer = useCallback(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return sendInvites([userEmail], {
              id: experiment.id,
              name: experiment.name,
              role: 'viewer'
            }, true);
          case 2:
            _context.next = 4;
            return dispatch(loadExperiments());
          case 4:
            _context.next = 6;
            return dispatch(setActiveExperiment(experiment.id));
          case 6:
            navigateTo(modules.DATA_EXPLORATION, {
              experimentId: experiment.id
            });
          case 7:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  })));
  var cloneExperiment = useCallback(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
    var url, newExperimentId;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            setExperimentCloning(true);
            url = "/v2/experiments/".concat(experiment.id, "/clone");
            _context2.next = 4;
            return fetchAPI(url, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              }
            });
          case 4:
            newExperimentId = _context2.sent;
            _context2.next = 7;
            return dispatch(loadExperiments());
          case 7:
            _context2.next = 9;
            return dispatch(setActiveExperiment(newExperimentId));
          case 9:
            setExperimentCloning(false);
            navigateTo(modules.DATA_MANAGEMENT, {
              experimentId: newExperimentId
            });
          case 11:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  })), [experiment.id]);
  var menuItems = [{
    key: 'view',
    onClick: addAsViewer,
    label: __jsx(DropdownLabel, {
      key: "view",
      title: "View",
      description: 'Viewers can explore all aspects of the project including ' + 'data processing settings and plots, clusters and UMAPs, ' + 'differential expression and a variety of plot visualizations. ' + 'However, Viewers cannot change settings or clusters.'
    })
  }, {
    key: 'copy',
    onClick: cloneExperiment,
    disabled: disableCloneForExperiments.includes(experiment.id),
    label: __jsx(DropdownLabel, {
      key: "clone",
      title: "Copy",
      description: 'By creating a copy, you will become the project Owner. ' + 'Owners have full control over data processing settings, ' + 'clusters including the generation of custom clusters, ' + 'and all changes are saved. Note that copying large projects ' + 'can take some time.'
    })
  }];
  return __jsx(_Dropdown, {
    menu: {
      items: menuItems
    },
    trigger: ['click']
  }, __jsx(_Button, {
    type: "primary",
    disabled: experimentCloning
  }, "Explore"));
};
ExploreSelect.defaultProps = {};
export default ExploreSelect;